import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal, inject, input } from '@angular/core';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { ITopBarConfig, INavAction, TOP_BAR_NOTICES } from '../../models';
import { ScreensizeService } from '../../services';
import { TopBarNoticeComponent } from '../top-bar-notice/top-bar-notice.component';

@Component({
  selector: 'lib-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    TranslateModule,
    IonBackButton,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonMenuButton,
    IonButton,
    TopBarNoticeComponent,
  ],
})
export class TopBarComponent {
  private readonly screensizeService = inject(ScreensizeService);

  public readonly topBarConfig = input.required<ITopBarConfig>();

  protected readonly notices = inject(TOP_BAR_NOTICES, { optional: true });

  protected readonly isDesktopView: Signal<boolean> = this.screensizeService.isDesktopView;
  protected readonly isXsDown: Signal<boolean> = this.screensizeService.isXsDown;

  protected readonly DEFAULT_BACK_HREF = '/tabs/dashboard';
  protected readonly DEFAULT_CANCEL_LABEL = 'general.cancel';
  protected readonly DEFAULT_NOTICES_LABEL = 'general.pending_documentation';

  protected showActionLabel(btn: INavAction): boolean {
    return !!btn.label && !this.isXsDown();
  }

  protected goToNotices(): void {
    this.notices?.openNotices();
  }
}
